// extracted by mini-css-extract-plugin
export default {"favicon":"WebsiteFavicon_favicon__48muK"};